<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="5.346" height="10.145" viewBox="0 0 5.346 10.145">
		<path
			id="Path_29758"
			data-name="Path 29758"
			d="M113.375,13.662,109,17.928l-4.375-4.266a.41.41,0,0,0-.7.287.37.37,0,0,0,.109.273l4.662,4.539a.43.43,0,0,0,.6,0l4.662-4.525a.428.428,0,0,0,.11-.294.378.378,0,0,0-.123-.287.408.408,0,0,0-.287-.116.39.39,0,0,0-.287.123Z"
			transform="translate(18.884 -103.928) rotate(90)"
			fill="#606266"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ArrowSvg',
};
</script>
